import { ReactNode } from 'react';
import { BoxProps, List, ListItem } from '@chakra-ui/react';

const listStyle = {
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
  alignItems: 'flex-start',
  padding: 0,
  width: '100%',
  background: 'brand.white',
  border: '1px solid',
  borderColor: 'brand.dark-green-200',
  borderRadius: '4px',
  whiteSpace: 'unset',
};

const itemStyle = {
  width: '100%',
  border: 'none',
  padding: 'padding_8',
  position: 'relative',
  ':after': {
    content: '""',
    background: 'brand.dark-green-200',
    position: 'absolute',
    bottom: '0',
    height: '1px',
    left: 'padding_8',
    right: 'padding_8',
  },
  ':last-of-type': {
    ':after': {
      display: 'none',
    },
  },
};

type WrappedListItemProps = {
  sx?: BoxProps['sx'];
  children?: ReactNode;
  className?: string;
};

const WrappedListItem = ({ sx, children, ...props }: WrappedListItemProps) => {
  return (
    <ListItem sx={{ ...itemStyle, ...sx }} {...props}>
      {children}
    </ListItem>
  );
};

type Props = {
  sx?: BoxProps['sx'];
  children?: ReactNode;
  ariaLabel?: string;
};

const WrappedList = ({ sx = {}, ariaLabel, children }: Props) => {
  return (
    <List sx={{ ...listStyle, ...sx }} aria-label={ariaLabel}>
      {children}
    </List>
  );
};

WrappedList.Item = WrappedListItem;

export default WrappedList;
